import $ from 'jquery';
import ApplicationController from './application_controller';

/**
 * Turbo-visits the selected option's value (a URL) when the select changes.
 *
 * Usage:
 *   <select data-controller="select-navigate">
 *     <option value="/some/path">Some page</option>
 *   </select>
 *
 * These selects are selectize-enhanced; selectize emits change via a jQuery
 * trigger on the original <select>, which native listeners (including
 * Stimulus data-action) never receive, so the handler is bound with jQuery.
 * Binding to the original element works whether selectize initializes
 * before, after, or never.
 */
export default class extends ApplicationController {
  connect() {
    this.onChange = () => {
      const url = this.element.value;
      if (url) {
        Turbo.visit(url);
      }
    };
    $(this.element).on('change', this.onChange);
  }

  disconnect() {
    $(this.element).off('change', this.onChange);
  }
}
